"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appVariablesSet = exports.appTypingUserPing = exports.appTypingSet = exports.appSettingsSet = exports.appScrolledSet = exports.appProductSet = exports.appInputValidationSet = exports.appEnvSet = exports.appContextReset = exports.appDebugSet = exports.appConversationIdSet = exports.appContextSet = exports.appBotProjectIdSet = exports.appBlockedSet = exports.appAgentTransfer = void 0;

var _LiveEngage = _interopRequireDefault(require("../../clients/LiveEngage"));

var _constants = require("../../constants");

var _types = require("../types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var appAgentTransfer = function appAgentTransfer() {
  return function _callee() {
    return regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return regeneratorRuntime.awrap(_LiveEngage["default"].init());

          case 2:
          case "end":
            return _context.stop();
        }
      }
    });
  };
};

exports.appAgentTransfer = appAgentTransfer;

var appBlockedSet = function appBlockedSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_BLOCKED_SET
    });
  };
};

exports.appBlockedSet = appBlockedSet;

var appBotProjectIdSet = function appBotProjectIdSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_BOT_PROJECT_ID_SET
    });
  };
};

exports.appBotProjectIdSet = appBotProjectIdSet;

var appContextSet = function appContextSet(value) {
  return function _callee2(dispatch) {
    return regeneratorRuntime.async(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return regeneratorRuntime.awrap(dispatch({
              payload: value,
              type: _types.APP_CONTEXT_SET
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    });
  };
};

exports.appContextSet = appContextSet;

var appConversationIdSet = function appConversationIdSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_CONVERSATION_ID_SET
    });
  };
};

exports.appConversationIdSet = appConversationIdSet;

var appDebugSet = function appDebugSet(value) {
  return function _callee3(dispatch) {
    return regeneratorRuntime.async(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return regeneratorRuntime.awrap(dispatch({
              payload: value,
              type: _types.APP_DEBUG_SET
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    });
  };
};

exports.appDebugSet = appDebugSet;

var appContextReset = function appContextReset() {
  return function _callee4(dispatch) {
    return regeneratorRuntime.async(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return regeneratorRuntime.awrap(dispatch({
              payload: _constants.CONTEXT_CHATBOTS_API,
              type: _types.APP_CONTEXT_SET
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    });
  };
};

exports.appContextReset = appContextReset;

var appEnvSet = function appEnvSet(value) {
  return function _callee5(dispatch) {
    return regeneratorRuntime.async(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (value !== _constants.ENV_STRINGS.prod && value !== _constants.ENV_STRINGS.test) value = _constants.ENV_STRINGS.dev;
            _context5.next = 3;
            return regeneratorRuntime.awrap(dispatch({
              payload: value,
              type: _types.APP_ENV_SET
            }));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    });
  };
};

exports.appEnvSet = appEnvSet;

var appInputValidationSet = function appInputValidationSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_INPUT_VALIDATION_SET
    });
  };
};

exports.appInputValidationSet = appInputValidationSet;

var appProductSet = function appProductSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_PRODUCT_SET
    });
  };
};

exports.appProductSet = appProductSet;

var appScrolledSet = function appScrolledSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_SCROLLED_SET
    });
  };
};

exports.appScrolledSet = appScrolledSet;

var appSettingsSet = function appSettingsSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_SETTINGS_SET
    });
  };
};

exports.appSettingsSet = appSettingsSet;

var appTypingSet = function appTypingSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_TYPING_SET
    });
  };
};

exports.appTypingSet = appTypingSet;

var appTypingUserPing = function appTypingUserPing() {
  return function (dispatch, getState) {
    var _getState = getState(),
        context = _getState.app.context;

    if (context === _constants.CONTEXT_LIVE_ENGAGE) {
      _LiveEngage["default"].handleTypingUserPing();
    }
  };
};

exports.appTypingUserPing = appTypingUserPing;

var appVariablesSet = function appVariablesSet(value) {
  return function (dispatch) {
    return dispatch({
      payload: value,
      type: _types.APP_VARIABLES_SET
    });
  };
};

exports.appVariablesSet = appVariablesSet;